import PrivateContentLayout from './PrivateContent';
import PublicContentLayout from './PublicContent';

const useLayouts = () => {
  return {
    PrivateContentLayout,
    PublicContentLayout,
  };
};

export default useLayouts;
